// sp-concept.js — le Concept, carte 52 (Signal v8, 06/10) : le lecteur vidéo différé, le
// panneau qui suit la lecture, les carrés du fil et de l'avancement.
//
// POURQUOI UN ASSET. Ces scripts vivaient en ligne dans sp-concept.liquid ; Shopify garde un
// cache de compilation des sections et servait un <script> périmé. Un asset porte un ?v=.
//
// POURQUOI PAS IntersectionObserver. Dans le navigateur d'atelier, l'observateur ne
// signalait jamais d'intersection : le calcul au défilement fait le même travail, et il se
// vérifie.
//
// Sans JavaScript, rien ne manque : chaque figure est aussi dans le flux (au téléphone),
// le panneau montre la fig. 1, et le bouton vidéo ne fait rien — la vidéo reste citée.
(function () {
  /* ── La vidéo se lit en grand, dans une fenêtre (artiste, 04/10). Le lecteur n'est créé
     qu'à l'ouverture, détruit à la fermeture pour que le son s'arrête. ── */
  var btn = document.querySelector('[data-sp-short-play]');
  var lecteur = document.querySelector('[data-sp-lecteur]');
  if (btn && lecteur && typeof lecteur.showModal === 'function') {
    btn.addEventListener('click', function () {
      var f = document.createElement('iframe');
      f.src = btn.getAttribute('data-embed');
      f.title = btn.textContent.trim();
      f.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.setAttribute('allowfullscreen', '');
      var c = lecteur.querySelector('[data-sp-lecteur-c]');
      c.innerHTML = '';
      c.appendChild(f);
      lecteur.showModal();
    });
    var x = lecteur.querySelector('[data-sp-lecteur-x]');
    if (x) x.addEventListener('click', function () { lecteur.close(); });
    lecteur.addEventListener('click', function (e) { if (e.target === lecteur) lecteur.close(); });
    lecteur.addEventListener('close', function () {
      var c = lecteur.querySelector('[data-sp-lecteur-c]');
      if (c) c.innerHTML = '';
      btn.focus();
    });
  } else if (btn) {
    btn.hidden = true;
  }

  /* ── Le moment en cours : celui dont le haut a passé le milieu de l'écran, ou celui que
     survole la souris. Il remplit les carrés du fil jusqu'à lui (lu / actif), ceux de
     l'avancement, et choisit la figure du panneau et sa légende. ── */
  var lec = document.querySelector('[data-sp-lec]');
  if (!lec) return;
  var moments = [].slice.call(lec.querySelectorAll('[data-sp-m]'));
  var figures = [].slice.call(lec.querySelectorAll('[data-sp-pf]'));
  var legendes = [].slice.call(lec.querySelectorAll('[data-sp-pc]'));
  var carres = [].slice.call(lec.querySelectorAll('[data-sp-avance] .sp-carre'));
  var liens = [].slice.call(document.querySelectorAll('[data-sp-idx-l]'));
  if (!moments.length) return;
  var survol = null;
  var dernier = null;

  function montre(n) {
    if (n === dernier) return;
    dernier = n;
    moments.forEach(function (m) { m.classList.toggle('is-lu', +m.getAttribute('data-sp-m') <= n); });
    carres.forEach(function (c, i) { c.classList.toggle('sp-carre--vide', i + 1 > n); });
    /* Une figure absente (pas de fichier) : le panneau garde la précédente. */
    var cible = null;
    for (var k = n; k >= 1 && !cible; k--) cible = lec.querySelector('[data-sp-pf="' + k + '"]');
    figures.forEach(function (f) { f.classList.toggle('is-on', f === cible); });
    var num = cible ? cible.getAttribute('data-sp-pf') : '';
    legendes.forEach(function (l) { l.classList.toggle('is-on', l.getAttribute('data-sp-pc') === num); });
    var nn = ('0' + n).slice(-2);
    liens.forEach(function (a) { a.classList.toggle('is-on', a.getAttribute('data-sp-idx-l') === nn); });
  }

  function courant() {
    if (survol) return survol;
    var milieu = window.innerHeight / 2;
    var n = 1;
    moments.forEach(function (m) { if (m.getBoundingClientRect().top <= milieu) n = +m.getAttribute('data-sp-m'); });
    return n;
  }

  moments.forEach(function (m) {
    m.addEventListener('mouseenter', function () { survol = +m.getAttribute('data-sp-m'); montre(survol); });
    m.addEventListener('mouseleave', function () { survol = null; montre(courant()); });
  });
  montre(courant());
  window.addEventListener('scroll', function () { montre(courant()); }, { passive: true });
  window.addEventListener('resize', function () { dernier = null; montre(courant()); });
})();
